import React, { Component } from "react";
import EkoModal from "../../components/elements/EkoModal";
import { toastr } from "react-redux-toastr";
import Api from "../../util/Api";
import { EkoFormInputText, EkoFormSelect } from "../../components/elements/EkoForm";

class ModalDriverInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draft: {},
      templates: [],
      saving: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal && nextProps.showModal !== this.props.showModal) {
      const rows =
        nextProps.driverRows && nextProps.driverRows.rows
          ? nextProps.driverRows.rows
          : [];
      this.setState({ draft: { ...(rows[0] || {}) } }, () => {
        this.fetchTemplates();
      });
    }
  }

  fetchTemplates = () => {
    if (this.state.templates && this.state.templates.length > 0) return;
    Api.get("/transportationContract/driverInfoTemplates", (res, err) => {
      if (err) return;
      const templates = Array.isArray(res && res.templates) ? res.templates : [];
      const normalized = templates.map((t) => ({
        ...t,
        label: t.label || t.full_name || t.license_no || "",
      }));
      this.setState({ templates: normalized });
    });
  };

  closeModal = () => {
    this.props.closeModal();
  }

  onTemplateSelect = (value) => {
    const id = parseInt(value, 10);
    if (!id) return;
    const selected = (this.state.templates || []).find((t) => parseInt(t.id, 10) === id);
    if (!selected) return;
    this.setState({
      draft: {
        ...this.state.draft,
        full_name: selected.full_name || "",
        license_no: selected.license_no || "",
        issue_place: selected.issue_place || "",
        issue_date: selected.issue_date || "",
        issue_place_date:
          selected.issue_place_date ||
          `${selected.issue_place || ""}${selected.issue_date ? " - " + selected.issue_date : ""}`,
        address: selected.address || "",
        home_phone: selected.home_phone || "",
        mobile_phone: selected.mobile_phone || "",
      },
    });
  };

  onFieldChange = (id, value) => {
    this.setState({
      draft: {
        ...this.state.draft,
        [id]: value,
      },
    });
  };

  onSave = () => {
    const draft = this.state.draft || {};
    const hasAnyValue = Object.keys(draft).some((k) => draft[k] !== null && draft[k] !== "");
    if (hasAnyValue && !draft.full_name) {
      toastr.warning("Dikkat!", "Şoför Adı Soyadı boş olamaz");
      return;
    }
    this.props.saveDriver({
      rows: [{ ...draft }],
    });
    this.props.closeModal();
  }

  render() {
    const templateInputProps = {
      onChange: (_, value) => this.onTemplateSelect(value),
      onMount: () => {},
      formData: {},
      errors: {},
    };
    const inputProps = {
      onChange: this.onFieldChange,
      onMount: () => {},
      formData: this.state.draft || {},
      errors: {},
    };

    return (
      <EkoModal
        bsSize={"large"}
        dialogClassName={""}
        showModal={this.props.showModal}
        title={"Şoför Bilgileri"}
        onHide={this.closeModal}
        spinner={this.state.saving}
        modalBodyStyle={{ padding: "15px 20px" }}
      >
        <div className="row">
          <div className="col-md-12">
            <EkoFormSelect
              searchable={true}
              isVertical={true}
              {...templateInputProps}
              id={"driver_template_id"}
              defaultText={"ÖNCEKİ KAYITLARDAN SEÇİN"}
              optionId={"id"}
              options={this.state.templates}
              optionValue={"label"}
              label={"Kayıtlı Şoför Bilgileri"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"full_name"}
              type={"text"}
              isVertical={true}
              label={"Adı Soyadı"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"license_no"}
              type={"text"}
              isVertical={true}
              label={"Ehliyet No"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"issue_place"}
              type={"text"}
              isVertical={true}
              label={"Verildiği Yer"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"issue_date"}
              type={"date"}
              isVertical={true}
              label={"Verildiği Tarih"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"address"}
              type={"textarea"}
              rows={3}
              isVertical={true}
              label={"Adresi"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"home_phone"}
              type={"text"}
              isVertical={true}
              label={"Şoför Ev Tel"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"mobile_phone"}
              type={"text"}
              isVertical={true}
              label={"Şoför Cep Tel"}
            />
          </div>
          <div className="col-md-12" style={{ textAlign: "right", marginTop: 6 }}>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.closeModal}
            >
              İptal
            </button>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginLeft: 8 }}
              onClick={this.onSave}
            >
              Kaydet
            </button>
          </div>
        </div>
      </EkoModal>
    );
  }
}

export default ModalDriverInfo;
